import { gql } from '@apollo/client'
import { ID } from '../IQueryData'
import {
  IBulkParkingPoolActionPayload,
  BULK_PARKING_POOL_ACTION_FIELDS,
} from './bulkParkingPoolAction'

export interface IBulkAssignParkingPoolProfileVars {
  profile: ID
  logins: string[]
}

export interface IBulkAssignParkingPoolProfileData {
  bulkAssignParkingPoolProfile: IBulkParkingPoolActionPayload
}

export const BULK_ASSIGN_PARKING_POOL_PROFILE = gql`
  mutation bulkAssignParkingPoolProfile($profile: ID!, $logins: [String!]!) {
    bulkAssignParkingPoolProfile(profile: $profile, logins: $logins) {
      ${BULK_PARKING_POOL_ACTION_FIELDS}
    }
  }
`
